export default __webpack_public_path__ + "static/media/facebook ad.00bc7fdc.png";